import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Label} from 'react-bootstrap'
import * as helpers from '../lib/HelperFunctions'

class RecommendationLabel extends Component {
    
    render() {
        let style='info'
        let text=''
        const numSteps = 2
        const effort = Math.min(this.props.effortRating, numSteps)
        const impact = Math.min(this.props.impactRating, numSteps)
        const num = helpers.calcRatingNum(effort,impact)
        switch (num) {
            case 1:
                style='danger'
                text='AVOID'                
                break
            case 2:
                style='warning'
                text='MAYBE'                
                break
            case 3:
                style='info'
                text='PROJECT'                
                break
            case 4:
                style='success'
                text='DO'                
                break
            default:
                style='default'
                text='unrated'
                break
        }
        return (
            <Label bsStyle={style}>{text}</Label>
        )
    }
}
RecommendationLabel.propTypes = {
    effortRating: PropTypes.number.isRequired,
    impactRating: PropTypes.number.isRequired,
}

export default RecommendationLabel



// WEBPACK FOOTER //
// ./src/components/RecommendationLabel.js